import { tenantIdStorage } from "@sg-protect/core";
import { useSyncExternalStore } from "react";
import { useTenants } from "./TenantsContext.tsx";
import { useHasActiveProtectAccess } from "./useHasActiveProtectAccess.ts";

export function useGovernanceTenantId(): string | undefined {
    const tenantId = useSyncExternalStore(tenantIdStorage.subscribe, tenantIdStorage.get);

    return tenantId ?? undefined;
}

// Re-consent clears the tenant while the workspace stays consented; a request sent without one 403s as notConsented.
export function useCanQueryTenantData(): boolean {
    const hasActiveProtectAccess = useHasActiveProtectAccess();
    const isConsented = useTenants().tenants?.primaryTenant?.isConsented === true;
    const tenantId = useGovernanceTenantId();

    return hasActiveProtectAccess && isConsented && tenantId !== undefined;
}

export function getGovernanceTenantId(): string | undefined {
    return tenantIdStorage.get() ?? undefined;
}
